import { render, staticRenderFns } from "./ModuleInformationConfirmModal.vue?vue&type=template&id=0a753a66&scoped=true&"
import script from "./ModuleInformationConfirmModal.vue?vue&type=script&lang=js&"
export * from "./ModuleInformationConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./ModuleInformationConfirmModal.vue?vue&type=style&index=0&id=0a753a66&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a753a66",
  null
  
)

export default component.exports